import { ListCategoryDoc } from '../../redux-toolkits/categories/categories.type'
import { CategorySectionSummary } from './category-section-summary'

export const CreatorSectionSummary = ({
  categories = [],
}: {
  categories?: ListCategoryDoc[]
}) => (
  <CategorySectionSummary label="Creator sections" categories={categories} />
)
